export const getExtent = values => {
  if(values){
    const min = Math.min(...values)
    const max = Math.max(...values)
    return [min, max]
  }
  return [0,0]
}
